import React from 'react';

import TrainIcon from 'assets/svg/transportation/metro.svg';
import BusIcon from 'assets/svg/transportation/bus.svg';
import BikeIcon from 'assets/svg/transportation/bike.svg';
import CarIcon from 'assets/svg/transportation/car.svg';
import { TransportationSectionType } from 'store/state/insightsContext';

const sectionToIconMap: { [key in TransportationSectionType]: React.ComponentType<React.SVGProps<SVGSVGElement>> } = {
  train: TrainIcon,
  bus: BusIcon,
  bike: BikeIcon,
  car: CarIcon,
  transit: BusIcon,
};

export const SectionIcon: React.FunctionComponent<{ sectionId: TransportationSectionType }> = ({ sectionId }) => {
  const Icon = sectionToIconMap[sectionId];
  return <Icon width={20} height={20} />;
};
